// extracted by mini-css-extract-plugin
export default {"disclaimer":"PGTlnx_5B9xCTNKhNroD"};